/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementAlertsMapping extends models.JiraServiceManagementMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementAlertsMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementAlertsMapping>): JiraServiceManagementAlertsMapping {
        let obj = Object.assign(new JiraServiceManagementAlertsMapping(), model);
        JiraServiceManagementAlertsMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementAlertsMapping>): JiraServiceManagementAlertsMapping {
        if (!model) return null;
        return JiraServiceManagementAlertsMapping.newInstance(<JiraServiceManagementAlertsMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementAlertsMapping) {
        if (!obj) return;

        models.JiraServiceManagementAlertsMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementAlertsMapping): boolean {
        if (models.JiraServiceManagementMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementAlertsMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.JiraServiceManagementIncidentManagementConfigurationMappingForAlerts.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Alert Attribute enums.
     */
    description_attributes: Array<models.DescriptionAttributeForItsmAlert>;

    /**
     * List of Alert Attribute mappings.
     */
    attribute_mappings: Array<models.JiraServiceManagementIncidentManagementConfigurationMappingForAlerts>;

}
